import { render, staticRenderFns } from "./DispalyIm.vue?vue&type=template&id=6efaa973&"
import script from "./DispalyIm.vue?vue&type=script&lang=js&"
export * from "./DispalyIm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports